/**
 * Converts the event date label to the final text label.
 * @param {string} label - The option facet label to convert.
 * @returns {string} - The final text label for the option.
 */
export default function convertEventDateFacetOptionLabel(label: string): string {
  // label looks like "December 2024|2024-12"4
  return label.split('|')[0];
}
